import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TripLogStatsDataInterface } from '../../models/dashboard/trip-log/trip-log-stats';

interface IInitialState {
  triplogStatsData?: TripLogStatsDataInterface;
}

const initialState: IInitialState = {
  triplogStatsData: undefined,
};

const triplogStatsSlice = createSlice({
  name: 'triplogStatsSlice',
  initialState,
  reducers: {
    setTriplogStatsData(state, action: PayloadAction<TripLogStatsDataInterface>) {
      state.triplogStatsData = action.payload;
    },
  },
});

export const triplogStatsActions = triplogStatsSlice.actions;
export default triplogStatsSlice.reducer;
